import { createSlice } from "@reduxjs/toolkit";

export const MessageSlice = createSlice({
  name: "Message",
  initialState: {
    MsgRes: {},
    MessageList: [],
    previewdownload: "",
    totalcount: "noData",
    SecureMessageList: [],
    PatNamesList: "",
    NewMsgs: 0,
    chatContext: null,
  },
  reducers: {
    SendMsgData: (data) => {
      return data;
    },

    MsgResponse: (state, action) => {
      state.MsgRes = action.payload;
    },
    getMessagerList: (data) => {
      return data;
    },
    setMessageList: (state, action) => {
      state.MessageList = action.payload;
    },
    getPreviewDownload: (filename) => {
      return filename;
    },
    setPreviewDownload: (state, action) => {
      state.previewdownload = action.payload;
      state.Loading = false;
    },
    getUnreadCount: (state) => {
      return state;
    },
    setTotalUnreadCount: (state, action) => {
      state.totalcount = action.payload;
    },
    gettotalUnreadCount: (state) => {
      return state;
    },
    getSecureMessageList: (data) => {
      return data;
    },
    setSecureMessageList: (state, action) => {
      state.SecureMessageList = action.payload;
    },
    getSecureSearch: (data) => {
      return data;
    },
    setSecureSearch: (state, action) => {
      state.PatNamesList = action.payload;
    },
    setNewMsgCount: (state, action) => {
      state.NewMsgs = action.payload;
    },
    setChatContext: (state, action) => {
      state.chatContext = action.payload;
    },
  },
});

export const {
  SendMsgData,
  MsgResponse,
  getMessagerList,
  setMessageList,
  getPreviewDownload,
  setPreviewDownload,
  getUnreadCount,
  gettotalUnreadCount,
  setTotalUnreadCount,
  setSecureMessageList,
  getSecureMessageList,
  getSecureSearch,
  setSecureSearch,
  setNewMsgCount,
  setChatContext,
} = MessageSlice.actions;

export default MessageSlice.reducer;
